import { onMounted, onUnmounted, reactive } from 'vue';

/**
 * Generic countdown to a fixed target.
 *
 * @param {number | string | Date} targetMsOrDate - Target as epoch ms, ISO string, or Date.
 * @returns {{ days: number, hours: number, minutes: number, seconds: number, isPast: boolean }}
 */
export function useCountdown(targetMsOrDate) {
  const targetMs =
    typeof targetMsOrDate === 'number' ? targetMsOrDate : new Date(targetMsOrDate).getTime();

  const state = reactive({ days: 0, hours: 0, minutes: 0, seconds: 0, isPast: false });

  let intervalId = null;

  function update() {
    const diff = targetMs - Date.now();
    if (diff <= 0) {
      state.days = 0;
      state.hours = 0;
      state.minutes = 0;
      state.seconds = 0;
      state.isPast = true;
      stop();
      return;
    }
    const totalSeconds = Math.floor(diff / 1000);
    state.seconds = totalSeconds % 60;
    state.minutes = Math.floor(totalSeconds / 60) % 60;
    state.hours = Math.floor(totalSeconds / 3600) % 24;
    state.days = Math.floor(totalSeconds / 86400);
  }

  function stop() {
    if (intervalId !== null) {
      clearInterval(intervalId);
      intervalId = null;
    }
  }

  function start() {
    if (intervalId !== null || state.isPast) return;
    update();
    if (!state.isPast) {
      intervalId = setInterval(update, 1000);
    }
  }

  function onVisibilityChange() {
    if (document.hidden) {
      stop();
    } else {
      start();
    }
  }

  onMounted(() => {
    document.addEventListener('visibilitychange', onVisibilityChange);
    if (!document.hidden) {
      start();
    }
  });

  onUnmounted(() => {
    stop();
    document.removeEventListener('visibilitychange', onVisibilityChange);
  });

  return state;
}
